import React from 'react'
import styles from '../../styles/styles.module.css'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  errorMsg?: React.ReactElement | string
}

const Input: React.FC<Props> = ({ errorMsg, ...props }) => {
  return (
    <div className="inputWrapper">
      <input {...props} />
      {errorMsg && (
        <div className={styles.errorMsg} data-i18n={errorMsg}>
          {errorMsg}
        </div>
      )}
    </div>
  )
}

export default Input
